import { useParams } from "react-router-dom";
import { PlatformGate } from "@/components/platform-admin/platform-gate";
import { SchoolDetail } from "@/components/platform-admin/school-detail";

/** MT-1 Plan 2 S14 (FR-8 UI): `/platform/admin/schools/:tenantId`, behind the platform gate. */
export function PlatformSchoolPage() {
  const { tenantId = "" } = useParams();
  return (
    <PlatformGate>
      {() => (
        <main className="mx-auto max-w-4xl px-4 py-10" data-testid="platform-school">
          <SchoolDetail tenantId={tenantId} />
        </main>
      )}
    </PlatformGate>
  );
}
